import React from 'react'
import * as routes from '../redux/actions/routing/route.actions'
import Home from './Home'
import Settings from './Settings'
import Adventure from './Adventure'
import Squad from './Squad'
import Unit from './UnitPage'
import Battle from './Battle'
import BattleResult from './BattleResult'

const scenes = {
    [routes.GOTO_HOME]: <Home />,
    [routes.GOTO_SETTINGS]: <Settings />,
    [routes.GOTO_ADVENTURE]: <Adventure />,
    [routes.GOTO_SQUAD]: <Squad />,
    [routes.GOTO_UNIT]: <Unit />,
    [routes.GOTO_BATTLE]: <Battle />,
    [routes.GOTO_BATTLE_RESULT]: <BattleResult />,
}

export default scenes
